﻿/**
 * LeanIQ Offer Ritual — sticky fruit scroll.
 * Desktop: sticky fruitLayer (CSS) + optional parallax.
 * Mobile cover: same pin feel via transform on existing mobile fruits —
 * no CSS layout changes (look stays identical at rest).
 */
(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MQ_DESK = window.matchMedia('(min-width: 760px)');

  function init(root) {
    if (!root || root.dataset.liqRitualReady === '1') return;
    root.dataset.liqRitualReady = '1';

    const enableParallax = root.dataset.parallax !== 'false';
    const deskFruits = root.querySelectorAll('.liq-ritual__fruits--desk .liq-ritual__fruit[data-speed]');
    const deskLayer = root.querySelector('.liq-ritual__fruits--desk');
    const mobileLayer = root.querySelector('.liq-ritual__fruits--mobile');
    const mobileCover = root.classList.contains('liq-ritual--mobile-cover');

    deskFruits.forEach(function (el) {
      el.dataset.baseTransform = el.style.transform || '';
    });

    let ticking = false;

    function resetMobilePin() {
      if (!mobileLayer) return;
      mobileLayer.style.transform = '';
      mobileLayer.style.visibility = '';
      mobileLayer.style.willChange = '';
    }

    function update() {
      ticking = false;
      const rect = root.getBoundingClientRect();
      const viewH = window.innerHeight || 1;
      const inPlay = rect.bottom > 0 && rect.top < viewH;

      // —— Mobile: pin existing fruit layer (desktop sticky feel), look unchanged at rest ——
      if (!MQ_DESK.matches && mobileCover && mobileLayer && !REDUCE) {
        if (!inPlay) {
          mobileLayer.style.visibility = 'hidden';
          mobileLayer.style.transform = '';
          mobileLayer.style.willChange = '';
        } else if (rect.top < 0) {
          // Counter-scroll so fruits stay in the viewport like position:sticky
          mobileLayer.style.visibility = '';
          mobileLayer.style.willChange = 'transform';
          mobileLayer.style.transform = 'translate3d(0,' + Math.round(-rect.top) + 'px,0)';
        } else {
          // Resting — exact design look, no transform
          resetMobilePin();
        }
      } else if (mobileLayer) {
        resetMobilePin();
      }

      // —— Desktop: parallax on sticky desk fruits ——
      if (!MQ_DESK.matches || !deskFruits.length) {
        deskFruits.forEach(function (el) {
          el.style.transform = el.dataset.baseTransform || '';
        });
        if (deskLayer) deskLayer.style.visibility = '';
        return;
      }

      if (deskLayer) deskLayer.style.visibility = inPlay ? '' : 'hidden';

      if (REDUCE || !enableParallax) {
        deskFruits.forEach(function (el) {
          el.style.transform = el.dataset.baseTransform || '';
        });
        return;
      }

      const progress = Math.min(1, Math.max(0, -rect.top / Math.max(rect.height - viewH, 1)));
      deskFruits.forEach(function (el) {
        const speed = parseFloat(el.dataset.speed || '0.15');
        const base = el.dataset.baseTransform || '';
        const y = Math.round(progress * speed * -80);
        el.style.transform = base + ' translate3d(0,' + y + 'px,0)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-liq-ritual]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-liq-ritual]') || (e.target.matches && e.target.matches('[data-liq-ritual]') ? e.target : null)
      : null;
    if (root) {
      root.dataset.liqRitualReady = '';
      init(root);
    }
  });
})();
